const options: Array<{ id: string; value: "en" | "sv"; name: string }> = [
    {
        id: "en",
        value: "en",
        name: "English",
    },
    {
        id: "sv",
        value: "sv",
        name: "Svenska",
    },
];

export { options };
